import api from '../../../../api/client';

export const SEARCH_FIELD_OPTIONS = [
  { value: 'Rule Name', label: 'Rule Name' },
  { value: 'Alias', label: 'Alias' },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

export const TOOLS_OPTIONS = [
  { key: 'print', label: 'Print Report', icon: 'print' },
  { key: 'export_excel', label: 'Export Excel', icon: 'description' },
  { key: 'export_pdf', label: 'Export PDF', icon: 'picture_as_pdf' },
];

function mapBackendToFrontend(item) {
  if (!item) return null;
  const isArchived = Boolean(item.Archive ?? item.archive ?? false);
  return {
    id: item.ID ?? item.id,
    ruleName: item.Name ?? item.ruleName ?? item.name ?? '',
    name: item.Name ?? item.ruleName ?? item.name ?? '',
    alias: item.Alias ?? item.alias ?? '',
    swipeTimeAfter: Number(item.SwipeTimeAfter ?? item.swipe_time_after ?? item.swipeTimeAfter ?? 0),
    swipeTimeBefore: Number(item.SwipeTimeBefore ?? item.swipe_time_before ?? item.swipeTimeBefore ?? 0),
    lateHalfDayDeduct: Number(item.LateHalfDayDeduct ?? item.late_half_day_deduct ?? item.lateHalfDayDeduct ?? 0),
    earlyHalfDayDeduct: Number(item.EarlyHalfDayDeduct ?? item.early_half_day_deduct ?? item.earlyHalfDayDeduct ?? 0),
    noOfLateEarlyMarks: Number(item.LateMarksHF ?? item.late_marks_hf ?? item.noOfLateEarlyMarks ?? 0),
    lateEarlyDaysDeduct: Number(item.DaysDeduct ?? item.days_deduct ?? item.lateEarlyDaysDeduct ?? 0),
    earlyGoHf: Number(item.EarlyGoHF ?? item.early_go_hf ?? item.earlyGoHf ?? 0),
    earlyGoDaysDeduct: Number(item.EalryGoDaysDeduct ?? item.early_go_days_deduct ?? item.earlyGoDaysDeduct ?? 0),
    sandwitchPresent: Boolean(item.SandWitchPresent ?? item.sand_witch_present ?? item.sandwitchPresent ?? false),
    status: isArchived ? 'Inactive' : 'Active',
  };
}

function mapFrontendToBackend(payload) {
  const name = (payload.ruleName || payload.name || '').trim();
  const alias = (payload.alias || '').trim() || null;
  const swipeTimeAfter = Number(payload.swipeTimeAfter || 0);
  const swipeTimeBefore = Number(payload.swipeTimeBefore || 0);
  const lateHalfDayDeduct = Number(payload.lateHalfDayDeduct || 0);
  const earlyHalfDayDeduct = Number(payload.earlyHalfDayDeduct || 0);
  const lateMarksHf = Number(payload.noOfLateEarlyMarks || payload.late_marks_hf || payload.LateMarksHF || 0);
  const daysDeduct = Number(payload.lateEarlyDaysDeduct || payload.days_deduct || payload.DaysDeduct || 0);
  const earlyGoHf = Number(payload.earlyGoHf || payload.EarlyGoHF || 0);
  const earlyGoDaysDeduct = Number(payload.earlyGoDaysDeduct || payload.EalryGoDaysDeduct || 0);
  const sandwichPresent = Boolean(payload.sandwitchPresent || payload.SandWitchPresent);
  const isArchive = payload.status === 'Inactive' ? 1 : 0;

  return {
    Name: name,
    Alias: alias,
    SwipeTimeAfter: swipeTimeAfter,
    SwipeTimeBefore: swipeTimeBefore,
    LateHalfDayDeduct: lateHalfDayDeduct,
    EarlyHalfDayDeduct: earlyHalfDayDeduct,
    LateMarksHF: lateMarksHf,
    DaysDeduct: daysDeduct,
    EarlyGoHF: earlyGoHf,
    EalryGoDaysDeduct: earlyGoDaysDeduct,
    SandWitchPresent: sandwichPresent,
    Archive: isArchive,

    // camelCase aliases for resilience
    name,
    alias,
    swipe_time_after: swipeTimeAfter,
    swipe_time_before: swipeTimeBefore,
    late_half_day_deduct: lateHalfDayDeduct,
    early_half_day_deduct: earlyHalfDayDeduct,
    late_marks_hf: lateMarksHf,
    days_deduct: daysDeduct,
    early_go_hf: earlyGoHf,
    early_go_days_deduct: earlyGoDaysDeduct,
    sand_witch_present: sandwichPresent,
    archive: isArchive,
  };
}

export const attendanceRulesApi = {
  getRecords: async (filters = {}) => {
    const params = {
      search: filters.searchText?.trim() || undefined,
      search_field: filters.searchField || undefined,
      status_filter: filters.status && filters.status !== 'All' ? filters.status : undefined,
      page: 1,
      page_size: 200,
    };
    const { data } = await api.get('/payroll/attendance-rules/', { params });
    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    let list = items.map(mapBackendToFrontend);

    if (filters.status && filters.status !== 'All') {
      list = list.filter((r) => r.status === filters.status);
    }
    return list;
  },

  getRecordById: async (id) => {
    const { data } = await api.get(`/payroll/attendance-rules/${id}`);
    return mapBackendToFrontend(data);
  },

  createRecord: async (payload) => {
    const body = mapFrontendToBackend(payload);
    const { data } = await api.post('/payroll/attendance-rules/', body);
    return data;
  },

  updateRecord: async (id, payload) => {
    const body = mapFrontendToBackend(payload);
    const { data } = await api.put(`/payroll/attendance-rules/${id}`, body);
    return data;
  },

  archiveRecord: async (id) => {
    const { data } = await api.post(`/payroll/attendance-rules/${id}/archive`);
    return data;
  },

  deleteRecord: async (id) => {
    const { data } = await api.delete(`/payroll/attendance-rules/${id}`);
    return data;
  },

  getAttendanceRulesReport: async (filters = {}) => {
    return attendanceRulesApi.getRecords(filters);
  },
};
